import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import { modalZIndex } from 'style/styled-components/cssGlobalVariables';

export { PageWrapper, Title, SelectHint, DeviceHint, DeviceList, SignOutButton, Icon } from '../../DevicePageCommon.css';

export const OverlayPageWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--color-dark-background);
    z-index: ${modalZIndex};
    overflow: auto;
`;
